export default [
    {
		path: "/files",
		component: () => import("../views/Files/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
]
